
import React from "react";
import { Navigate } from "react-router-dom";

const ProtectedRoute = ({ requiredPermission, children }) => {
  const isLoggedIn = localStorage.getItem('isLoggedIn');
  const role = localStorage.getItem('role');
  const isSuperAdmin = role === 'superadmin' || localStorage.getItem('is_superuser') === 'true';

  if (!isLoggedIn) {
    return <Navigate to="/LoginPage" replace />;
  }

  if (isSuperAdmin) {
    return children;
  }

  if (requiredPermission) {
    let permissions = [];
    try {
      permissions = JSON.parse(localStorage.getItem('permissions') || '[]');
    } catch (e) {
      permissions = [];
    }
    if (!permissions.includes(requiredPermission)) {
      return <Navigate to="/unauthorized" replace />;
    }
  }

  return children;
};

export default ProtectedRoute;

